'use client';
import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { convertInlineToReactCSS } from '@benzinga/frontend-utils';

export interface GoBankRateOfferingsBlockProps {
  gbr_pub_id?: string;
  gbr_placement?: string;
  gbr_company_product?: string;
  gbr_width?: string;
  gbr_height?: string;
  gbr_inline_style: string;
}

export const GoBankRateOfferingsBlock: React.FC<GoBankRateOfferingsBlockProps> = ({
  gbr_height = 250,
  gbr_inline_style,
  gbr_placement = '',
  gbr_pub_id,
  gbr_width = 700,
}) => {
  const [preparedIframeURL, setPreparedIframeURL] = React.useState<string>('');
  const [inlineStyle, setInlineStyle] = React.useState<React.CSSProperties>({});
  const pathname = usePathname();
  const searchParams = useSearchParams();
  React.useEffect(() => {
    const clickId = searchParams?.get('utm_click_id');

    const query = [
      `targeting[category]=`,
      `targeting[company_product]=${encodeURIComponent(gbr_placement)}`,
      `targeting[costid]=944`,
      `targeting[pub_inventory]=${encodeURIComponent(pathname ?? '')}`,
      ...(clickId ? [`vendor_click_id=${encodeURIComponent(clickId)}`] : []),
    ].join('&');

    setPreparedIframeURL(`https://products.gobankingrates.com/pub/${gbr_pub_id}?${query}`);

    if (gbr_inline_style) {
      setInlineStyle(convertInlineToReactCSS(gbr_inline_style));
    }
  }, [gbr_inline_style, gbr_placement, gbr_pub_id, pathname, searchParams]);

  return (
    <div className="block">
      <iframe
        height={`${gbr_height}px`}
        scrolling="no"
        src={preparedIframeURL}
        style={inlineStyle}
        width={`${gbr_width}px`}
      ></iframe>
    </div>
  );
};
